import type { SearchFilterSetItem } from "~/client/components/search/hooks/useSavedSearchFilterSets";
import type { SearchConditionFilterSet } from "~/client/components/search/SearchConditionFilterSet";
import { searchPath } from "~/client/generated/routes";

const appendQuery = (params, keywords: ReadonlyArray<string>, filterSet: SearchConditionFilterSet) => {
  const query = [...keywords, ...filterSet.excludeKeywords.map((e) => `-${e}`)];
  params.append("query", query.join(" "));
};

const appendDateGte = (params, filterSet: SearchConditionFilterSet) => {
  if (filterSet.dateGte && filterSet.dateGte.toString().length > 0) {
    params.append("date_gte", filterSet.dateGte);
  }
};

const appendUserAccounts = (params, filterSet: SearchConditionFilterSet) => {
  filterSet.authorUsers.forEach((a) => {
    if (a.account) {
      params.append("user_accounts[]", a.account);
    }
  });
};

const appendGroupIds = (params, filterSet: SearchConditionFilterSet) => {
  filterSet.groups.forEach((g) => {
    if (g.databaseId) {
      params.append("group_ids[]", g.databaseId.toString());
    }
  });
};

const appendFolderRelayIds = (params, filterSet: SearchConditionFilterSet) => {
  filterSet.folders.forEach((f) => {
    if (f.id) {
      params.append("folder_relay_ids[]", f.id);
    }
  });
};

const appendResourceTypes = (params, filterSet: SearchConditionFilterSet) => {
  filterSet.resourceTypes.forEach((e) => {
    params.append("resource_types[]", e);
  });
};

const appendArchived = (params, filterSet: SearchConditionFilterSet) => {
  params.append("archived", String(filterSet.isArchived));
};

const appendLikedByMe = (params, filterSet: SearchConditionFilterSet) => {
  params.append("liked_by_me", String(filterSet.isLikedByMe));
};

const buildSearchParams = (keywords: ReadonlyArray<string>, filterSet: SearchConditionFilterSet): string => {
  const params = new URLSearchParams();
  appendQuery(params, keywords, filterSet);
  appendDateGte(params, filterSet);
  appendUserAccounts(params, filterSet);
  appendGroupIds(params, filterSet);
  appendFolderRelayIds(params, filterSet);
  appendResourceTypes(params, filterSet);
  appendArchived(params, filterSet);
  appendLikedByMe(params, filterSet);
  return params.toString();
};

export const buildSearchPathWithParams = (
  keywords: ReadonlyArray<string>,
  filterSet: SearchConditionFilterSet,
): string => `${searchPath()}?${buildSearchParams(keywords, filterSet)}`;

export const buildSearchPathWithParamsBySearchFilterSet = (query: string, filterSet: SearchFilterSetItem): string => {
  const keywords = query.split(/\s+/);
  return buildSearchPathWithParams(keywords, filterSet);
};
